export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "FileUploadWorker-c28d83d3efa791f3d865.worker.js");
}
